import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import BreadcrumbNext from '@spa/shared/svg/breadcrumb-next';
import { Wrapper, Item } from './styles';
import { getTranslatedTitle } from '@spa/shared/utils/translations';

const CustomBreadcrumbs = ({ homeUrl, cityName, cityUrl, neighborhoodName, neighborhoodUrl, pageTitle }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const translatedTitle = Array.isArray(pageTitle) ? getTranslatedTitle(pageTitle, language) : pageTitle;

  return (
    <Wrapper>
      <Item>
        <a href={homeUrl}>{t('Home')}</a>
        <BreadcrumbNext />
      </Item>
      <Item>
        <a href={cityUrl}>
          {t('Student accommodation in')} {cityName || ''}
        </a>
        <BreadcrumbNext />
      </Item>
      {neighborhoodName && (
        <Item>
          <a href={neighborhoodUrl}>{neighborhoodName}</a>
          <BreadcrumbNext />
        </Item>
      )}
      {translatedTitle && <Item>{translatedTitle}</Item>}
    </Wrapper>
  );
};

CustomBreadcrumbs.propTypes = {
  homeUrl: PropTypes.string.isRequired,
  cityName: PropTypes.string,
  cityUrl: PropTypes.string.isRequired,
  neighborhoodName: PropTypes.string,
  neighborhoodUrl: PropTypes.string,
  pageTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        locale_code: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        main: PropTypes.bool
      })
    )
  ])
};

export default CustomBreadcrumbs;
